var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1820_8151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9583 0H1.04167C0.765399 0 0.500448 0.111942 0.305097 0.311199C0.109747 0.510456 0 0.780707 0 1.0625L0 15.9375C0 16.2193 0.109747 16.4895 0.305097 16.6888C0.500448 16.8881 0.765399 17 1.04167 17H18.9583C19.0951 17 19.2306 16.9725 19.357 16.9191C19.4833 16.8657 19.5982 16.7875 19.6949 16.6888C19.7916 16.5901 19.8684 16.473 19.9207 16.3441C19.9731 16.2152 20 16.077 20 15.9375V1.0625C20 0.922971 19.9731 0.784807 19.9207 0.655899C19.8684 0.52699 19.7916 0.409861 19.6949 0.311199C19.5982 0.212537 19.4833 0.134274 19.357 0.0808779C19.2306 0.0274823 19.0951 0 18.9583 0Z",
    fill: "#B1BADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1441 4.28187L10.3607 10.1001C10.2481 10.1966 10.1057 10.2496 9.95864 10.2496C9.81155 10.2496 9.66917 10.1966 9.55656 10.1001L2.77739 4.29887C2.71501 4.24446 2.66374 4.17804 2.62653 4.10342C2.58931 4.0288 2.56687 3.94743 2.56049 3.86396C2.5541 3.78049 2.5639 3.69656 2.58932 3.61695C2.61474 3.53734 2.65528 3.46362 2.70864 3.4L2.97739 3.07487C3.08389 2.94575 3.23624 2.86497 3.40104 2.85024C3.56584 2.8355 3.72965 2.888 3.85655 2.99625L9.95031 8.2195L16.0732 2.975C16.1999 2.86651 16.3635 2.81364 16.5283 2.82798C16.6931 2.84232 16.8456 2.92269 16.9524 3.0515L17.2211 3.37662C17.275 3.44094 17.3157 3.51553 17.341 3.59607C17.3663 3.6766 17.3756 3.76147 17.3685 3.84571C17.3613 3.92996 17.3378 4.01191 17.2992 4.08679C17.2607 4.16167 17.208 4.22799 17.1441 4.28187Z",
    fill: "#F9F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1820_8151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.f2beb2b0b9a806dcd640d2d57cbc6b55.svg";
export { ForwardRef as ReactComponent };